import React, { FC, useContext, useEffect, useState } from "react";
import { getIcon } from "../Shared/Util";
import { IRecord, ITableActions } from "../Interfaces/TableInterface";

interface IProps {
    record: IRecord,
    viewDisplay: boolean, 
    editDisplay: boolean,
    downloadDisplay: boolean,
    defaultAction: ITableActions
}

const FileIcon: FC<IProps> = ({ record, viewDisplay, editDisplay, downloadDisplay, defaultAction }) => {

    useEffect(() => {
    }, []);


   

    if (record.icon === "") {

        //If view, edit and standard download are disabled, AND view pdf rendition or download pdf rendition is enabled AND display file type icon is enabled then we show the pdf icon
        if (!viewDisplay && !editDisplay && !downloadDisplay && (defaultAction === ITableActions.DownloadPDF || defaultAction === ITableActions.DisplayPDF)) {
            return (
                <>
                    {getIcon("pdf", record.isEditable, record.childCount)}
                </>
            )
        }
        else {
            return (
                <>
                    {getIcon(record.extension, record.isEditable, record.childCount)}
                </>
            )
        }

    }

    if (record.icon !== "") {
        return (
            <> 
                <img src={record.icon} style={{ marginRight: "auto", display: "block", width: 30, height: 30, marginLeft: record.childCount === 0 ? "28px" : "0px" }} id={`${record.uri}-icon`} alt='RecordIcon' />
            </>
           
        ) 
    }

    return <></>;
}

export default FileIcon;